import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { numWaitingVisitorsAtom, totalUnreadMessageCountAtom } from "./state";
import { pluralizeString } from "../utils";
import { setAlertTitle, setDefaultFaviconAndTitle } from "../metadata";
import { useTranslate } from "@growtherapy/i18n";

function formatNotificationTitle(
  numberWaiting: number,
  unreadMessageCount: number,
): string {
  if (numberWaiting) {
    return `(${numberWaiting}) ${pluralizeString(
      numberWaiting,
      "client",
    )} waiting`;
  }
  if (unreadMessageCount) {
    return `(${unreadMessageCount}) ${pluralizeString(
      unreadMessageCount,
      "message",
    )}`;
  }
  return "";
}

export function useShowNotificationInFaviconAndTitle() {
  const t = useTranslate();
  const unreadMessageCount = useAtomValue(totalUnreadMessageCountAtom);
  const numberWaiting = useAtomValue(numWaitingVisitorsAtom);

  useEffect(
    function showNotificationInFaviconAndTitle() {
      if (!numberWaiting && !unreadMessageCount)
        return setDefaultFaviconAndTitle(t);
      setAlertTitle(formatNotificationTitle(numberWaiting, unreadMessageCount));
    },
    [t, numberWaiting, unreadMessageCount],
  );
}
